<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="error">
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text> Are you sure you want to <b class="font-weight-bold">CURRENT</b> batch? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      batchId: {
        type: Number,
        required: true,
      },    
    },
    data () {
      return {
        progressing: false,
        menu: null,
      }
    },

    methods: {
      submitForm () {
        this.progressing = true

        this.$api.companySalaryBatch().destroy(this.batchId)
          .then(response => {
            this.$snack({ message: 'Batch Deleted' })
            this.$emit('deleted')

            this.progressing = false
            this.menu = false
          })
          .catch(() => {
            this.progressing = false
          })
      },

    },
  }
</script>
